import { NOTIFICATION_BROADCAST_TYPE } from "@/entities/notification-broadcast";
import { useEventBusListener } from "@/modules/event-bus";

import { useJobModuleActionFailed } from "./job-module-action-failed.hook";

const JobModuleActionFailed = () => {
  const { runAction } = useJobModuleActionFailed();

  useEventBusListener(NOTIFICATION_BROADCAST_TYPE.JOB_MODULE_FAILED, runAction);

  return <></>;
};

export default JobModuleActionFailed;
